<template>
  <div class="aboutMobile">
    <div class="companyInfo">
      <div class="companyInfo_txt" v-html="aboutTxt">
      </div>
      <img src="https://cdn.youjiajk.com/companyInfoImg2.png" style="width: 100%;height:5.55rem;" />
    </div>

    <img src="https://cdn.youjiajk.com/aboutMobile2.png" style="width: 100%;height:9.17rem;" />
    <img src="https://cdn.youjiajk.com/aboutMobile3.png" style="width: 100%;height:6.68rem;" />
  </div>
</template>

<script>
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
export default {
  data () {
    return {
      swiperOption: {
        // loop: true,
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      reRender: false,
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  props: {
    newsList: {
      type: Array,
      default: []
    },
    teamList: {
      type: Array,
      default: []
    },
    aboutTxt: {
      type: String,
      default: ''
    }
  },
  created () {
    setTimeout(() => {
      this.reRender = true
    }, 100)
  },
  methods: {
    goPage (href) {
      window.open(href, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.aboutMobile {
  background: #F8F9FB;
}

.companyInfo {
  background: #FFFFFF;
  padding: 0.8rem 0.35rem 0.3rem;

  .companyInfo_txt {
    margin-bottom: 0.35rem;
    font-size: 0.24rem;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #666666;
    line-height: 0.36rem;
    margin-bottom: 0.4rem;

    p {
      font-size: 0.24rem;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      text-align: left;
      color: #666666;
      line-height: 0.36rem;
      margin-bottom: 0.4rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

}

img {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/aboutMobile.vue